import { render, staticRenderFns } from "./fiche-aim.vue?vue&type=template&id=2146e3d3"
import script from "./fiche-aim.vue?vue&type=script&setup=true&lang=js"
export * from "./fiche-aim.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports